<template lang="pug">
.basicFilter
    .prefix
        .filter-icon.mdi(v-if='prefix.icon' :class='prefix.icon')
        label.filter-label(v-if='prefix.label') {{ prefix.label }}
    .content
        input.content-filter(
            v-model='filtro',
            @input='$emit("filtro:pesquisar", $event.target.value)'
        )
</template>

<script>
export default {
    name: 'FilterBasicComponent',
    props: {
        prefix: {
            type: Object,
            default: () => ({
                icon: 'mdi-magnify',
                label: 'Filtrar'
            })
        }
    },
    data() {
        return {
            filtro: ''
        };
    },

    methods: {
        limpar() {
            this.filtro = '';
            this.$emit('filtro:limpar', this.filtro);
        },
        pesquisar() {
            this.$emit('filtro:pesquisar', this.filtro);
        },
    },
};
</script>

<style lang="scss" scoped>
.basicFilter {

    display: flex;
    align-items: center;
    justify-content: flex-start;

    .prefix {

        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-evenly;

        height: 32px;
        padding: 0px 5px;

        background-color: var(--primary-light-green);
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;

        color: var(--primary-white);

        .filter-icon {
            color: white;
        }

        .filter-label {}

    }

    .content {

        width: 100%;

        .content-filter {
            padding: 3px;
            height: 22px;
            width: 100%;
            border: 2px solid var(--primary-light-green) !important;
            border-top-right-radius: 5px;
            border-bottom-right-radius: 5px;
        }

        .content-filter:focus-visible {
            outline: none;
        }
    }


}

.basicFilter:focus-within {

    .prefix {
        background-color: var(--primary-green);
    }

    .content-filter {
        border: 2px solid var(--primary-green) !important;
    }
}
</style>
    